import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { auth } from "../../db/config";
import { Link } from "react-router-dom";
import PickUp from "../../images/pickup.png";
import "./ourplan.css";
export default function OurPlan() {
  const investmentReducer = useSelector((state) => state.investmentReducer);
  const getInvestmentDetails = investmentReducer ? investmentReducer.plans : "";
  // console.log(getInvestmentDetails);
  const [user, setuser] = useState(false);
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user.uid) {
        setuser(true);
      } else {
        setuser(false);
      }
    });
  }, [user]);
  const handleLogin=()=>{
    alert("Please login to start investing")
  }
  const handleAlert=()=>{
    alert("Please login to start investing")
  }
  return (
    <div>
      <div class="investment_plans float_left">
        <div class="investment_overlay"></div>
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_wrapper_dark">
                <h4> our plans </h4>
                <h3> Our Investment Plans </h3>
                {
                  user?<div
                  class="col-lg-12 col-sm-6 col-12 "
                  style={{ marginTop: "60px" }}
                >
                  <Link to="/deposit">
                    <div class="investment_box_wrapper float_left bonus__div"></div>
                  </Link>
                  <Link to="/deposit">
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        background: "white",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "700",
                        paddingBottom: "20px",
                        color: "#00AAEF",
                      }}
                    >
                      (Invest minimum of $1 million USD) 65 percent ROI in 25
                      days + FORD F-150 2020 truck
                      <span style={{ marginLeft: "10px" }}>
                        {" "}
                        <img src={PickUp} alt="logo" />
                      </span>
                    </div>
                  </Link>
                </div>:<div
                  class="col-lg-12 col-sm-6 col-12 "
                  style={{ marginTop: "60px" }}
                  onClick={handleAlert}
                >
                 
                    <div class="investment_box_wrapper float_left bonus__div"></div>
                 
               
                    <div
                      style={{
                        width: "100%",
                        textAlign: "left",
                        background: "white",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "700",
                        paddingBottom: "20px",
                        color: "#00AAEF",
                      }}
                    >
                      (Invest minimum of $1 million USD) 65 percent ROI in 25
                      days + FORD F-150 2020 truck
                      <span style={{ marginLeft: "10px" }}>
                        {" "}
                        <img src={PickUp} alt="logo" />
                      </span>
                    </div>
                
                </div>
                }
              </div>
            </div>
            {user ? (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                <Link to="/deposit">
                  <div class="investment_box_wrapper float_left">
                    <div class="investment_icon_circle">
                      <i class="flaticon-bar-chart"></i>
                    </div>
                    <div class="investment_border_wrapper"></div>
                    <div class="investment_content_wrapper">
                      <h1>
                        <a href="/deposit">silver plan</a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[3].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </Link>
              </div>
            ) : (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12" onClick={handleLogin}>
                <div class="investment_box_wrapper float_left">
                  <div class="investment_icon_circle">
                    <i class="flaticon-bar-chart"></i>
                  </div>
                  <div class="investment_border_wrapper"></div>
                  <div class="investment_content_wrapper">
                    <h1>
                      <a href="#">silver plan</a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[3].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              </div>
            )}

            {user ? (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                <a href="/deposit">
                  <div class="investment_box_wrapper float_left">
                    <div class="investment_icon_circle red_info_circle">
                      <i class="flaticon-money"></i>
                    </div>
                    <div class="investment_border_wrapper red_border_wrapper"></div>
                    <div class="investment_content_wrapper red_content_wrapper">
                      <h1>
                        <a href="/deposit">Bronze Plan</a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[1].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn red_btn_plans">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </a>
              </div>
            ) : (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12" onClick={handleLogin}>
                <div class="investment_box_wrapper float_left">
                  <div class="investment_icon_circle red_info_circle">
                    <i class="flaticon-money"></i>
                  </div>
                  <div class="investment_border_wrapper red_border_wrapper"></div>
                  <div class="investment_content_wrapper red_content_wrapper">
                    <h1>
                      <a href="#">Bronze Plan</a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[1].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn red_btn_plans">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              </div>
            )}
            {user ? (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                <a to="/deposit">
                  <div class="investment_box_wrapper float_left">
                    <div class="investment_icon_circle blue_icon_circle">
                      <i class="flaticon-gold"></i>
                    </div>
                    <div class="investment_border_wrapper blue_border_wrapper"></div>
                    <div class="investment_content_wrapper blue_content_wrapper">
                      <h1>
                        <a href="/deposit">copper plan</a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[0].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn blue_btn_plans">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </a>
              </div>
            ) : (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12" onClick={handleLogin}>
                <div class="investment_box_wrapper float_left">
                  <div class="investment_icon_circle blue_icon_circle">
                    <i class="flaticon-gold"></i>
                  </div>
                  <div class="investment_border_wrapper blue_border_wrapper"></div>
                  <div class="investment_content_wrapper blue_content_wrapper">
                    <h1>
                      <a href="#">copper plan</a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[0].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn blue_btn_plans">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              </div>
            )}

            {user ? (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
                <a href="/deposit">
                  <div class="investment_box_wrapper float_left">
                    <div class="investment_icon_circle green_info_circle">
                      <i class="flaticon-medal"></i>
                    </div>
                    <div class="investment_border_wrapper green_border_wrapper"></div>
                    <div class="investment_content_wrapper green_content_wrapper">
                      <h1>
                        <a href="/deposit">gold plan</a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[4].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn green_plan_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </a>
              </div>
            ) : (
              <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12" onClick={handleLogin}>
                <div class="investment_box_wrapper float_left">
                  <div class="investment_icon_circle green_info_circle">
                    <i class="flaticon-medal"></i>
                  </div>
                  <div class="investment_border_wrapper green_border_wrapper"></div>
                  <div class="investment_content_wrapper green_content_wrapper">
                    <h1>
                      <a href="#">gold plan</a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[4].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn green_plan_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
